import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export type SigurIntegration = {
  id: number;
  name: string;
  owner_id: number;
  location_id: number;
  credentials_id: number;
  token: string;
};

export type SigurIntegrationCreate = {
  name: string;
  location_id: number;
  credentials_id: number;
  owner_id: number; // костыль ебись оно всё конём
};

export type SigurIntegrationUpdate = {
  name: string;
  location_id: number;
  credentials_id: number;
  owner_id: number;
};

export const SigurIntegrationsAPI = (baseUrl: string) => {
  return {
    list: async () => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/sigur/?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<SigurIntegration[]>;
    },
    get: async (id: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.get(
        `${baseUrl}/sigur/${id}?business_profile_id=${businessProfileId}`,
        undefined,
        true,
      )) as ApiResponse<SigurIntegration>;
    },
    create: async (sigurIntegrationData: SigurIntegrationCreate) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/sigur/?business_profile_id=${businessProfileId}`,
        sigurIntegrationData,
        true,
      )) as ApiResponse<SigurIntegration>;
    },
    update: async (
      id: number,
      sigurIntegrationData: SigurIntegrationUpdate,
    ) => {
      Object.assign(sigurIntegrationData, {
        id,
      });
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.put(
        `${baseUrl}/sigur/${id}?business_profile_id=${businessProfileId}`,
        sigurIntegrationData,
        true,
      )) as ApiResponse<SigurIntegration>;
    },
    delete: async (id: number, credentialsId: number) => {
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.delete(
        `${baseUrl}/sigur/${id}?business_profile_id=${businessProfileId}&credentials_id=${credentialsId}`,
        true,
      )) as ApiResponse<{}>;
    },
  };
};
